// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"f58e7c47","255":"956dfaae"}[chunkId] + ".chunk.js";
};